import { ColumnResizingContextProvider } from 'src/contexts/ColumnResizingContext/ColumnResizingContext';
import { Content } from 'src/contexts/ContentContext';
import { NoData, Table } from 'src/tables/Table';
import { ContentId } from 'src/utils/constants/contentId';
import { UserSetting } from 'src/WebApiController';

import { ReportTableV2Props } from '../ReportTableCommon/ReportTableCommon.types';
import { useReportDetailsTableV2 } from '../ReportTableCommon/useReportDetailsTableV2';
import {
  SaleReportTableColumnDefContextProviderV2,
  useSaleReportTableColumnDefV2,
} from './SaleReportTableColumnDefContextV2';

export const SaleReportTableV2 = ({
  report,
  reportValueTypes,
  ...rest
}: ReportTableV2Props) => {
  return (
    <SaleReportTableColumnDefContextProviderV2
      report={report}
      reportValueTypes={reportValueTypes}
    >
      <SaleReportTableInternal report={report} {...rest} />
    </SaleReportTableColumnDefContextProviderV2>
  );
};

const SaleReportTableInternal = (props: ReportTableV2Props) => {
  const { displayedColumnsConfig = [] } = useSaleReportTableColumnDefV2();

  const { isReportConfigEmpty, tableProps, data } = useReportDetailsTableV2({
    ...props,
    displayedColumnsConfig,
  });

  return isReportConfigEmpty ? (
    <></>
  ) : data?.length > 0 ? (
    <ColumnResizingContextProvider
      userSettingId={UserSetting.ReportV2SaleColumnWidths}
    >
      <Table {...tableProps} />
    </ColumnResizingContextProvider>
  ) : (
    <NoData>
      <Content id={ContentId.NoReportText} />
    </NoData>
  );
};

export default SaleReportTableV2;
